import script from "./doubleSide.vue?vue&type=script&setup=true&lang=js"
export * from "./doubleSide.vue?vue&type=script&setup=true&lang=js"

import "./doubleSide.vue?vue&type=style&index=0&id=4c6d9e24&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6d9e24"]])

export default __exports__